import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Footer from 'components/Footer/Footer';
import './style.css';
// import StaticBanner from 'components/Banner/StaticBanner';


import Button from 'react-bootstrap/Button';
import { Image, Container, Row, Col } from 'react-bootstrap';
//import eventBanner from "Assets/internationalpk/ipk2021_Branding.jpeg";

//import eventBanner from "Assets/internationalpk/sean_rules_2.png"; // 2021
import eventBanner from "Assets/internationalpk/ipk2022_Branding.003.jpeg";

//import tellUsWhatYouLoveImg from "Assets/internationalpk/tell_us_what_you_love_2021.jpeg"; // 2021
import tellUsWhatYouLoveImg from "Assets/internationalpk/ipk2022_Branding.005.jpeg";

// import timetable_1 from "Assets/internationalpk/Timetable 3up 2 columns.001 (1).jpeg"; // 2021
import timetable_1 from "Assets/internationalpk/ipk2022_Branding.006.jpeg";

import peopleImg from "Assets/internationalpk/ipk2022_Branding.007.jpeg"

import closingImg from "Assets/internationalpk/ipk2022_Branding.004.jpeg"

import img1 from "Assets/internationalpk/2022/1.png";
import img2 from "Assets/internationalpk/2022/2.png";
import img3 from "Assets/internationalpk/2022/3.png";
import img4 from "Assets/internationalpk/2022/4.png";
import img5 from "Assets/internationalpk/2022/5.png";
import img6 from "Assets/internationalpk/2022/6.png";

//import special_guests from "Assets/internationalpk/2022/special_guests_ipk2022.png";

// more images from 2/14/2022
import hours1 from "Assets/internationalpk/2022/Hour_01-06.png";
import hours2 from "Assets/internationalpk/2022/Hour_07-12.png";
import hours3 from "Assets/internationalpk/2022/Hour_13-18.png";
import hours4 from "Assets/internationalpk/2022/Hours_19-24.png";
import internation from "Assets/internationalpk/2022/International_PechaKucha_Day.png";
import special_guests from "Assets/internationalpk/2022/ipk2022_special_guests_3.png";


// import { getQueryString } from "utils/Helper";

import storytellingMadeEasyImg from "Assets/internationalpk/storytelling_made_easy_2021.png";

// import ipkMapImg from "Assets/internationalpk/ipk2021_map.jpeg";
import ipkLoveImg from "Assets/internationalpk/ipk2021_love.jpeg";

//import timetable_1 from "Assets/internationalpk/timetable_1.jpeg";
//import timetable_2 from "Assets/internationalpk/timetable_2.jpeg";
//import timetable_1 from "Assets/internationalpk/Timetable 3up 2 columns.001 (1).jpeg";
import timetable_2 from "Assets/internationalpk/Timetable 3up 2 columns.002 (1).jpeg";

import { apiUrl, user_Status, user_Status_Ver } from 'Api/Api';

import { local_routes } from 'utils/Routes';

import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';



//import timetable_3 from "Assets/Timetable 3up.003.jpeg";
//import timetable_4 from "Assets/Timetable 3up.004.jpeg";

import home from 'Assets/home.svg';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';

import UserContext from 'store/UserContext';

//const signup_link = "https://bit.ly/International_pechakucha_day_2021_zoom_registration";
const signup_link = "https://www.youtube.com/c/PechakuchaOrg/featured";
const download_ipk_images_link = "https://bit.ly/international_pechakucha_day_2021_logos";
const zoom_link = "https://bit.ly/ipk2022_zoom_registration";
const ipk_event_link = "https://www.pechakucha.com/events/international-pechakucha-day-2022-global";

const category_friendly_url_obj = {
  staging: 'international-pechakucha-day-2022',
  live: 'international-pechakucha-day-2022'
}

const event_uuid_obj = {
  staging: 'c46f1311-9854-4101-93fc-89d9fd0a42f6',
  live: 'b91cc9e8-0da1-4729-baf5-a78073a71232'
}


class InternationalPk extends Component {
    static contextType = UserContext;
    constructor(props) {
      super(props);
      
      this.state = {
        show_signup_modal: false,
        verification_modal_show: false,
      }
      
      /*
      this.supported_language_abbreviations = new Set();
      this.supported_language_abbreviations.add('en-US');
      this.supported_language_abbreviations.add('ja-JP');
      */
      
      this.pageText = {
        pkmaker_button: {
          'en-US': 'TELL US WHAT YOU LOVE',
          'ja-JP': 'あなたのLOVEについてシェア！'
        },
        join_livestream_button: {
          'en-US': 'Register now for FREE',
          'ja-JP': 'ライブ配信への参加はこちら！'
        },
        // signup_now_button: {
        //   'en-US': 'Sign up now for #ipk2021',
        //   'ja-JP': '参加登録はこちら #ipk2021'
        // },
        intro: {
          'en-US': <span>
            It’s time to celebrate creativity, optimism, and LOVE!
            This February 19th and 20th will mark PechaKucha’s birthday and our third annual International PechaKucha Day and treasured 24-hour, online-around-the-world event, with PechaKucha Cities participating in all 24 time zones, each broadcasting their local creativity to the world!
            We invite you to join this special global event!
            <br/>#ipk2022 !
          </span>,
          'ja-JP': <span>
            PechaKuchaのお誕生日をお祝いするイベント’International PechaKucha Day 2022’が、今年も帰ってきます! 第3回目を迎える今年は、2月19日(土)、20日(日)の週末に、世界を24のタイムゾーンに分け、過去2回のイベント同様、PechaKuchaの世界各都市を繋ぎます! 各都市のクリエイティビティを世界へ発信する、という24時間かけて世界一周するこの特別なグローバルイベントに、皆さんぜひご参加ください！ハッシュタグは
            <br/>#ipk2022!
          </span>
        },
        theme_love: {
          'en-US': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>iPK2022’s Theme: LOVE …and OPTIMISM!</span><br/>
            After hearing from you in 2021, it was a unanimous and resounding YES to keep last year’s theme of <span style={{ color: "red", fontWeight: "bold" }}>LOVE</span>!
            We just might keep International PK Day about LOVE <em>every year</em>, but to make 2022 unique we’ve added a “sub-theme” represented by the color YELLOW, splashed throughout iPK2022.
            It’s meaning - <span style={{ color: "red", fontWeight: "bold" }}>OPTIMISM</span>!<br/>
            <br/>
            So for this year's International PechaKucha Day, we’ll be traveling around the world, inviting presenters in our global network of 1275 cities to share their creativity as it relates to LOVE and OPTIMISM!
            We’re also inviting YOU to make a PechaKucha Presentation sharing your LOVE and OPTIMISM with the world!
            We’ll play some of the best throughout the 24-hour broadcast. Everyone can participate!            
            </span>,
          'ja-JP': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>テーマ : LOVE and OPTIMISM</span><br/>
            昨年2021年にご回答頂いたアンケート内容を元に、今年のテーマも引き続き「<span style={{ color: "red", fontWeight: "bold" }}>LOVE</span>」に決定致しました！そして、今年のロゴに差し色の黄色が現す通り、「<span style={{ color: "red", fontWeight: "bold" }}>OPTIMISM</span> (楽観)」！をサブテーマとして設けました<br/>
            <br/>
            今年は、LOVEとOPTIMISMに関わるクリエイティビティについて、世界1275都市に広がるPechaKucha Nightコミュニティーのプレゼンターの方々に発信して頂きます！そして、もちろん皆さんにも、LOVEとOPTIMISMのテーマにそったPechaKuchaプレゼンテーションを、ぜひ世界に向けて発信して欲しいと思います！ご投稿頂いたプレゼンテーションは、事前に選定の上、24時間のライブ配信中に、いくつかシェアさせて頂く予定です。皆さんのご投稿お待ちしています！
          </span>
        },
        when_where: {
          'en-US': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>When:</span><br/>
            The live stream begins at noon Tokyo time on 19th February, 2022.
            The event will run for 24-hours. Complete timetable found below.<br/>
            <br/>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Where:</span><br/>
            Join us on Zoom by registering for the event <a target="_blank" rel="noopener noreferrer" href={zoom_link}>here</a>.
            We will also broadcast it live on YouTube.<br/>
            <br/>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Who:</span><br/>
            Hosted by PechaKucha co-founders Mark Dytham and Astrid Klein as well as PechaKucha Night City organizers from around the world.
            Confirmed presenters range from well-known storytellers and business leaders to artists and designers.
          </span>,
          'ja-JP': <span>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>開催日時:</span><br/>
          PechaKuchaの誕生日、2月19日(土) 20日(日）です！週末開催ですので、ぜひ、ご都合のいいタイミングに、この24時間ライブ配信にご参加ください<br/>
          <br/>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>開催場所:</span><br/>
          Zoomを使って、世界中のPechaKucha 都市の主催者とリレー形式で繋がる予定です。各都市のイベント主催者が、割り当てられたタイムスロット内で、数人のプレゼンターをキュレートします。 2月19日(土）の東京時間の正午からスタートし、翌日2月20日の正午まで、すべてのプレゼンテーションをウェビナーとユーチューブで世界に向けて生配信します。<br/>
          </span>
        },
        participate: {
          'en-US': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>You can join us in a number of ways:</span><br/>
            <p style={{ marginLeft: "10px" }}>
              <ul>
                <li><a target="_blank" rel="noopener noreferrer" href={zoom_link}>Register</a> for the Zoom and tune in anytime to the #ipk2022 Livestream on Feb 19-20.</li>
                <li>Create a 20x20 or 10x10 PK presentation online using our PK Create Platform and tag it with #ipk2022. We'll feature some of the best throughout the Livestream! Start PK Creating NOW!</li>
                <li>Reach out to your local PechaKucha organizer and nominate yourself to be a presenter. We can help connect you too! Contact us using the handy 'Support' button in the lower right of your screen</li>
              </ul>
            </p>
        </span>,
          'ja-JP': <span>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>参加方法:</span><br/>
          <p style={{ marginLeft: "10px" }}>
            <ol>
              <li><a target="_blank" rel="noopener noreferrer" href={zoom_link}>視聴者として参加 !</a> - 今すぐズームウェビナー / Youtubeに登録して、2月19日スタートの#ipk2022ライブストリームにいつでもご参加ください。</li>
              <li><strong>プレゼンテーションに#ipk2022のタグをつけて事前投稿 !</strong> - 20枚x20秒、10枚x10秒のフォーマットで、事前投稿することもできます！投稿頂いたプレゼンテーションは、運営側でいくつか事前選定の上、ライブ配信中にシェアさせて頂く予定です。</li>
              <li><strong>お近くのPechaKucha Night都市で、プレゼンターとして参加！</strong> もし、お近くのPechaKucha Night都市のプレゼンターとして登壇したい！という方は、サイト右下の’Support’ボタンから、詳細についてお問い合わせください。</li>
            </ol>
          </p>
          </span>
        },
        what_this_means: {
          'en-US': <span>
            We really hope you can join us from where ever you are in the world and show us what you LOVE.
            With this optimism, we can help the world smile again!
            It's going to be a LOVE-filled 24 hours of connections and fun!
            <br/>
          </span>,
          'ja-JP': <span>
            この機会に、ぜひ皆さんがワクワクするモノ・コト・人について、ぜひ世界に向けて発信してください！皆さんからの沢山の「<span style={{ color: "red", fontWeight: "bold" }}>LOVE</span>」についてのプレゼンテーションをお待ちしております！今回も、皆さんとワクワクと笑顔をシェアできることを楽しみにしています！！
          </span>
        },
        headline_1: {
          'en-US': <span>
            Join us for a 24-hour worldwide celebration of creativity, optimism, and LOVE!
          </span>,
          'ja-JP': <span>
            世界のPechaKuchaコミュニティを巻き込んだ、24時間のライブストリームイベントにあなたも参加しませんか？
          </span>
        },
        headline_2: {
          'en-US': <span>
            Drop in anytime and hear inspiring stories by 100+ presenters across all continents, including many special guests.
          </span>,
          'ja-JP': <span>
            日本をはじめ、世界から届くLOVEとOPTIMISMをテーマとしたストーリーの数々に出会える、1年に1度のPechaKuchaの祭典！
          </span>
        }

      };
      
      
    }
    
    switchLanguage = (language_abbreviation) => {
      this.context.setLanguage(language_abbreviation);
    };
    
    goPkCreate = (go_uri) => {
      // need channel/event uuid
      this.props.history.push({
        pathname: go_uri,
        data: {
          source: {
            //entity_type: 'channels',
            //entity_uuid: this.state.getonwithit_channel_uuid,
            submit_event_uuid: event_uuid_obj[process.env.REACT_APP_PK_ENV],
            category_friendly_url_array: [category_friendly_url_obj[process.env.REACT_APP_PK_ENV]],
            referrer: '/internationalpk'
          }
        }
      });
      
    }
    
  checkUserEligible = (event) => {
    console.log("checkUserEligible",event);
    
    if (!user_Status) {
      console.error("NO user!");
      window.localStorage.setItem('login_success_redirect_uri',local_routes.pkcreation);
      this.setState({
        show_signup_modal: true
      });
      return false;
    }

    if (user_Status_Ver !== "1") {
      console.error("NO user is not verified!");
      window.localStorage.setItem('login_success_redirect_uri',local_routes.pkcreation);
        this.setState({
          verification_modal_show: true
        });
      return false;
    }
    
    // got verified user - make a PK!
    window.scrollTo(0, 0);
    this.goPkCreate(local_routes.pkcreation);
  }
    
    componentDidMount() {
      console.log("InternationalPk2022 componentDidMount");
    }
    componentDidUpdate() {
      console.log("InternationalPk2022 componentDidUpdate");
    }
    render() {
        if (!this.context.user_info) {
          return (
              <FullPageSpinner />
          );
        }        
        
        return (
            <React.Fragment>
                <Helmet defer={false}>
                    <title>International PechaKucha Day - February 19, 2022</title>
                    <meta name="description" content="One Day, Hundreds of Events, Thousands of PechaKucha Presentations" />
                    <meta property="og:image" content={`https://www.pechakucha.com${eventBanner}`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.pechakucha.com/internationalpk" />
                    <meta property="og:title" content="International PechaKucha Day - February 19, 2022" />
                    <meta property="og:description" content="One Day, Hundreds of Events, Thousands of PechaKucha Presentations" />
                </Helmet>
                <div>
                    {/* Banner Starts */}
                    <div style={{ marginTop: "5px" }}>
                        {/*<a target="_blank" rel="noopener noreferrer" href={signup_link}>*/}
                        <section className="bannerimg-head shrinkme" style={{ backgroundImage: `url( ${eventBanner})` }}>
                            <div className="container">
                            </div>
                        </section>
                        {/*</a>*/}
                    </div>
                    <div className="container ipk-container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">

                        <h1 style={{ textAlign: 'center', fontWeight: 'bolder', marginBottom: '20px' }}>{this.pageText.headline_1[this.context.language_abbreviation]}</h1>
                        
                        <p style={{ fontSize: 'larger', textAlign: 'center' }}>{this.pageText.headline_2[this.context.language_abbreviation]}</p>

                        {/* {this.pageText.intro[this.context.language_abbreviation]} */}

                        <br/>
                        <center>
                          <a target="_blank" rel="noopener noreferrer" href={zoom_link}>
                          <Button
                            variant="danger"
                            style={{ borderRadius: "24px", marginTop: "0px", marginBottom: "10px" }}
                            size="lg"
                          >
                            {this.pageText.join_livestream_button[this.context.language_abbreviation]}
                          </Button>
                          </a><br/>
                          <br/>
                          <a style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => this.switchLanguage('en-US')}>English</a> / <a style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => this.switchLanguage('ja-JP')}>Japanese</a>
                        </center>
                        
                        <br/>
                        
                        <p style={{ textAlign: 'center' }}>Special Guests Include:</p>

                      </div>
                    </div>

                   <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${special_guests})` }}>
                            <div className="container">
                            </div>
                        </section>
                    </div>
                   
                    
                    <div className="container ipk-container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        {this.pageText.when_where[this.context.language_abbreviation]}
                      </div>
                    </div>
                    
                    {/* 2/7/2022 new 2022 event images here */}
                    {/* 2/14/2022 new 2022 event images here */}
                    
                    <div className="container ipk-container image-prime" style={{ marginTop: "5px" }}>
                      <img src={hours1}/>
                    </div>

                    <div className="container ipk-container image-prime" style={{ marginTop: "0px" }}>
                      <img src={hours2}/>
                    </div>

                    <div className="container ipk-container image-prime" style={{ marginTop: "0px" }}>
                      <img src={hours3}/>
                    </div>
                    <div className="container ipk-container image-prime" style={{ marginTop: "0px", marginBottom: "20px" }}>
                      <img src={hours4}/>
                    </div>

        
                    {/*            
                    <div style={{ marginTop: "5px" }}>
                        
                        <section className="bannerimg-head-square" style={{ backgroundImage: `url( ${hours1})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>

                    <div style={{ marginTop: "0px" }}>
                        
                        <section className="bannerimg-head-square" style={{ backgroundImage: `url( ${hours2})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>

                    <div style={{ marginTop: "0px" }}>
                        
                        <section className="bannerimg-head-square" style={{ backgroundImage: `url( ${hours3})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>

                    <div style={{ marginTop: "0px", marginBottom: "10px" }}>
                        
                        <section className="bannerimg-head-square" style={{ backgroundImage: `url( ${hours4})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>
                    */}
                    
                    {/*
                    <div style={{ marginTop: "0px" }}>
                        
                        <section className="bannerimg-head-square" style={{ backgroundImage: `url( ${img5})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>

                    <div style={{ marginTop: "0px" }}>
                        
                        <section className="bannerimg-head-square-last" style={{ backgroundImage: `url( ${img6})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>
                    */}


                    {/*
                    <div style={{ marginTop: "5px" }}>
                        
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${timetable_1})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>
                    */}
                    
                    {/*
                    <div className="container ipk-container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        {this.pageText.participate[this.context.language_abbreviation]}
                      </div>
                    </div>


                    <center>  
                      <Button
                        variant="danger"
                        style={{ borderRadius: "24px", marginTop: "15px", marginBottom: "25px" }}
                        size="lg"
                        onClick={this.checkUserEligible}
                      >
                        {this.pageText.pkmaker_button[this.context.language_abbreviation]}
                      </Button>
                      
                    </center>
                    
                    <div className="container ipk-container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">

                        {this.pageText.theme_love[this.context.language_abbreviation]}
                      </div>
                    </div>


                    <div style={{ marginTop: "5px" }}>
                        
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${tellUsWhatYouLoveImg})` }}>
                            <div className="container">
                            </div>
                        </section>
                        
                    </div>




                    <div style={{ marginTop: "5px" }}>

                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${peopleImg})` }}>
                            <div className="container">
                            </div>
                        </section>

                      </div>               
                    */}
                    <center>
                      <a target="_blank" rel="noopener noreferrer" href={zoom_link}>
                      <Button
                        variant="danger"
                        style={{ borderRadius: "24px", marginTop: "0px", marginBottom: "10px" }}
                        size="lg"
                      >
                        {this.pageText.join_livestream_button[this.context.language_abbreviation]}
                      </Button>
                      </a>
                    </center>

                    <div className="container ipk-container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        {this.pageText.what_this_means[this.context.language_abbreviation]}
                      </div>
                    </div>

                    <div style={{ marginTop: "10px" }}>
                        {/*<Link to="/pkcreate">*/}
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${internation})` }}>
                            <div className="container">
                            </div>
                        </section>
                        {/*</Link>*/}
                    </div>               

              { !user_Status &&
                <SignupModal
                  show={this.state.show_signup_modal}
                  onHide={() => this.setState({show_signup_modal:false})}
                  reload={true}
                />
              }
        
              { user_Status_Ver !== "1" &&
                <VerificationModal
                  show={this.state.verification_modal_show}
                  onHide={() => this.setState({ verification_modal_show: false})}
                />
              }



    
                    <Footer
                      homeImg={home}
                      homeImgRef="/"
                      breadcrumbSubPage="International Pk"
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default InternationalPk;
